import { configureStore } from '@reduxjs/toolkit';
import { localStorageMiddleware } from './middleware';
import rootReducer from './rootReducer';

const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(localStorageMiddleware)
})

export default store;